<div class="panel panel-default" id="panel1">
  <div class="row" id="rowActionByFinanceTeam">
    <div class="col-md-12">
      <div class="panel-heading">
        <h4 class="panel-title">
          <a style="color: gray; font-size: 14px;">
            <b>Upload Records by Finance Team</b>
          </a>
        </h4>
      </div>
    </div>
    <div class="col-md-12">
      <div class="row" *ngIf="ErrorMessage.length > 0">
        <div class="col-md-12">
          <div style="font-size:small;">
            <img src="assets/img/error_icon.gif" /><span class="text-error" style="font-weight:bold;color:red;">The
              following errors were encountered on the page.</span>
          </div>
          <div id="divMainError" class="text-error"
            style="padding-top:0px; margin-bottom:10px;margin-left:25px; font-size:small; color:red">
            <span style="display:list-item" *ngFor="let item of ErrorMessage">{{item.message}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="row align-items-center">
        <span class="col-sm-4">
          <b>Please Upload File</b><span style="color: red;">*</span>
        </span>
        <div class="col-md-8">
          <input type="File" id="" name="file" (change)="UploadAttachment($event)" class="form-control"
            accept=".xlsx">
        </div>
        <div class="col-md-6 mt-3">
          <u><a (click)="DownloadFormat()">Download upload format</a></u>
        </div>
        <div class="col-md-6 mt-3 d-flex align-items-center justify-content-end column-gap-2">
          <button id="btnSubmit" type="button" title="Submit" class="btn btn-primary" (click)="submit()">
            <span>Upload</span>
          </button>
          <button type="button" class="btn btn-primary" mat-raised-button (click)="closeDialog()">
            <span>Close</span>
          </button>

        </div>
      </div>
    </div>
  </div>
</div>